import React, { useMemo, useState } from "react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Separator } from "@/components/ui/separator";
import { languages } from "@/lib/i18next";
import { CaretLeft, CaretRight, Check, Globe } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { localePathMap } from "@/lib/constants";
import { Mixpanel } from "@/lib/mixpanel";

const LanguageSettings = () => {
  const [open, setOpen] = useState(false);
  const { i18n, t } = useTranslation();

  const language = useMemo(() => {
    return i18n.language.split("-")[0];
  }, [i18n.language]);

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger data-testid="language-settings-button" className="w-full">
        <div className="flex flex-row items-center justify-between px-5 py-[15px]">
          <div className="flex flex-row items-center gap-2">
            <Globe size={24} color="white" />
            <span className="font-base font-medium text-white">
              {t("label.language_settings")}
            </span>
          </div>

          <div className="flex flex-row items-center gap-2">
            <span
              data-testid="current-language"
              className="text-sm font-medium text-white/60"
            >
              {t(`languages.${language}`)}
            </span>
            <CaretRight size={24} color="#E3EDFC" />
          </div>
        </div>
      </DrawerTrigger>
      <DrawerContent>
        <div className="hidden">
          <DrawerTitle>{t("title.language_settings")}</DrawerTitle>
          <DrawerDescription>{t("title.language_settings")}</DrawerDescription>
        </div>

        <DrawerHeader
          className="mb-5"
          leftButton={
            <DrawerClose>
              <CaretLeft size={24} color="#E3EDFC" />
            </DrawerClose>
          }
          title={t("title.language_settings")}
          rightButton={<span className="w-6" />}
        />
        <Separator />

        {languages.map((language) => (
          <React.Fragment key={language.code}>
            <button
              data-testid={`language-${language.code}`}
              role="button"
              onClick={() => {
                i18n.changeLanguage(language.code);
                setOpen(false);
                Mixpanel.track("Change Language", {
                  lang_code: language.code,
                  lang_name: language.name,
                });
              }}
              className="flex w-full flex-row items-center justify-between py-[15px]"
            >
              <div className="flex flex-row items-center gap-2">
                <span className="flex h-6 w-6 items-center text-2xl">
                  {language.flag}
                </span>
                <span className="text-[15px] font-medium text-white">
                  {language.name}
                </span>
              </div>
              {localePathMap[i18n.language as keyof typeof localePathMap] ===
                language.code && <Check size={20} color="#26C2DD" />}
            </button>
            <Separator />
          </React.Fragment>
        ))}
      </DrawerContent>
    </Drawer>
  );
};

export default LanguageSettings;
